/**
 * components/inspection/stageAccess.js — Хяналт шалгалтын ШАТНЫ ЭРХ.
 *
 * ЭРХ ХААНААС ИРДЭГ ВЭ:
 *   Хяналт шалгалт хийх этгээд дээр эрхийг **SSO дээр** тавьдаг. Өөрөөр
 *   хэлбэл шинэ хэлтсийн мэргэжилтнийг 4 дүгээр шатны шалгалт хийдэг
 *   болгохын тулд түүнд SSO-гоос доорх ролиудын НЭГИЙГ олгоно — код
 *   өөрчлөх шаардлагагүй.
 *
 *   Шинэ роль нэр гарвал зөвхөн `INSPECTOR_ROLES`-д нэмнэ. Энэ файл л
 *   цорын ганц хяналтын цэг.
 *
 * ШАТНЫ ХУВААРЬ:
 *   1-3 дугаар шат — БН-ийн ХАБ ажилтан, удирдлага
 *   4 дүгээр шат   — ХАБ хэлтэс ба эрх бүхий бусад хэлтсийн мэргэжилтэн
 *   бүх шат        — админ (sso_owner)
 *
 * ⚠ ЯАГААД ДУНДЫН ФАЙЛ БОЛГОВ:
 *   Өмнө нь энэ логик `/incident/register` ба `/inspection/register` хоёрт
 *   ТУС ТУСДАА хуулбарлагдсан байв. Хоёулаа мөн ижил алдаатай байсан —
 *   бүлгийг ролиос ӨМНӨ шалгадаг тул ХАБ хэлтсийн мэргэжилтэн (тэд бүлэг
 *   179-ийг зэрэг агуулдаг) «БН ХАБ» гэж ангилагдаж 4 дүгээр шатаа хийж
 *   чаддаггүй байлаа. Нэг газар төвлөрүүлснээр хоёр хуудас дахин зөрөхгүй.
 */

/**
 * 1-3 дугаар шатны үзлэг хийх бүлгүүд — БН-ийн ХАБ ажилтан ба удирдлага.
 *
 *   166 — цех дарга
 *   167 — шат шатны удирдлага
 *   168 — анхан шатны удирдах ажилтан (бригад)
 *   179 — БН-ийн ХАБ ажилтан
 *
 * (Бүлгийн тайлбар: hse_backend/Flask/Resources/XAB/morning.py)
 *
 * ⚠ 192 «дэд удирдлага» нь энд ОРООГҮЙ. Бусад газар (morning.py-ийн
 *   REGISTER_GROUPS, hazard_report.py-ийн CEX_SCOPE_GROUPS) 192-ыг хамтад нь
 *   тоолдог тул хэрэв дэд удирдлага ч 1-3 шатны үзлэг хийдэг бол энд нэмнэ.
 */
export const BN_HAB_GROUPS = ["166", "167", "168", "179"];

/**
 * БҮРЭН ЭРХИЙН бүлэг — SSO-д «174 · Бүрэн эрх» гэж тодорхойлогдсон.
 *
 * ⚠ Өмнө нь бүрэн эрхийг ЗӨВХӨН `sso_owner` РОЛЬ-оор таньдаг байв. Гэтэл
 * бодит хэрэглэгчид тэр роль байдаггүй, оронд нь бүлэг 174-ийг эзэмшдэг.
 * Ийм хүн 179 (БН-ийн ХЭМАБ ажилтан)-ыг зэрэг агуулдаг тул доод салаанд
 * унаж, 1-3 шатны хязгаарлагдмал харагдац авдаг байсан.
 *
 * SSO-гийн бүлгийн жагсаалт (Программ удирдах цонх → Бүлгийн тохиргоо):
 *   174 — Бүрэн эрх
 *   173 — ХАБЭА хэлтсийн мэргэжилтэн     (тодорхой чиглэл хариуцсан)
 *   380 — ХАБЭА хэлтсийн ХСБ хариуцсан   (тодорхой чиглэл)
 *   179 — Бүтцийн нэгжийн ХЭМАБ-н ажилтан
 * Тиймээс ЗӨВХӨН 174-ийг бүрэн эрх гэж үзнэ.
 */
export const FULL_ACCESS_GROUPS = ["174"];

/**
 * ─── SSO-гийн ЭРХЭЭР удирдах (үндсэн арга) ───────────────────────────────
 *
 * Хяналт шалгалтын ШАТНЫ эрхийг SSO дээрээс удирдана: «Программ удирдах
 * цонх → Эрхийн тохиргоо». Тэнд эрхийг ҮҮСГЭЭД бүлэгт оноодог, эрх нь
 * цаанаа цэсний Харах/Нэмэх/Засах/Устгахтай холбогддог. Ингэснээр ШИНЭ
 * бүлэг, шинэ хэлтэс нэмэгдэхэд КОД ЗАСАХ ШААРДЛАГАГҮЙ.
 *
 * SSO дээр АЛЬ ХЭДИЙН байгаа нэршлийн конвенц (Эрхийн тохиргооны жагсаалт):
 *   inspection_list_read / _add / _edit / _delete   — 1 дүгээр шат
 *       (бүлэг 166, 167, 168, 179-д оноогдсон)
 *   inspection_II_read  / _add / _edit / _delete / _approve   — 2 дугаар шат
 *   inspection_III_read / _add / _edit / _delete / _approve   — 3 дугаар шат
 *
 * ⚠ «list» гэдэг нь ерөнхий ЖАГСААЛТЫН эрх БИШ — 1 дүгээр шатны эрх юм.
 *   Нэр нь төөрөгдүүлэм тул энд тусгайлан тэмдэглэв.
 *
 * ✔ 4 дүгээр шатны эрх SSO дээр БАЙГАА (2026-08-08 баталгаажсан). Доорх
 *   (`inspection_IV_add`) үүсгэхэд энэ файл шууд ашиглана — доорх
 *   `STAGE_ADD_PERMISSIONS`-д аль хэдийн бичигдсэн.
 *
 * ⚠ `inspection_register_all`, `zurchil_add` зэргийг ЭНД ашиглаж БОЛОХГҮЙ:
 *   тэдгээр нь МОДУЛИЙН түвшний эрх бөгөөд анхан шатны мастерууд ч
 *   эзэмшдэг (ж: ТН 92540 — бүлэг 168/179). Тэднээр шат тодорхойлбол 400
 *   гаруй хүн 4 дүгээр шатны эрх авна.
 *
 * Эрх хараахан оноогоогүй бол доорх БҮЛГИЙН нөөц логик хэвээр ажиллана —
 * тиймээс энэ өөрчлөлт одоогийн зан төлөвийг эвдэхгүй.
 */
export const STAGE_ADD_PERMISSIONS = {
  // Шат бүрд ХЭД ХЭДЭН нэр зөвшөөрнө — алийг нь эзэмшсэн ч тухайн шат
  // нээгдэнэ. Ингэснээр ирээдүйд SSO дээр нэрийг жигдрүүлэхэд (ж:
  // `inspection_list_add` → `inspection_I_add`) код засах шаардлагагүй.
  1: ["inspection_list_add", "inspection_I_add"], // ✔ байгаа (166,167,168,179)
  2: ["inspection_II_add"], // ✔ байгаа
  3: ["inspection_III_add"], // ✔ байгаа
  // ✔ БАТАЛГААЖСАН (2026-08-08). SSO дээр 4 дүгээр шатны бүлэг эрх бий:
  //     inspection_IV_add · inspection_IV_read · inspection_IV_show
  //     · inspection_IV_delete
  //   Энд ЗӨВХӨН `_add`-ыг ашиглана — бүртгэх эрхийг л шат нээхэд тооцно.
  //   (`_read`/`_show` нь харах эрх тул шат нээх үндэслэл болохгүй.)
  4: ["inspection_IV_add"],
};

/** Бүх 4 шатны зөрчил бүртгэх нэгдсэн эрх (заавал биш, товчлол). */
export const STAGE_ALL_PERMISSION = "inspection_stage_all";

function hasPermission(user, name) {
  const roles = Array.isArray(user?.userroles) ? user.userroles : [];
  const sso = Array.isArray(user?.roles) ? user.roles : [];
  return roles.includes(name) || sso.includes(name);
}

/**
 * Хэрэглэгчийн бүртгэх эрхтэй ШАТУУДЫГ буцаана.
 *
 * @returns {number[]} ж: [1,2,3] · [4] · [1,2,3,4] · [] (эрхгүй)
 *
 * Эрэмбэ:
 *   1. админ                        → бүх шат
 *   2. `inspection_stage_all`       → бүх шат
 *   3. `inspection_<N>_add` эрхүүд  → яг тэр шатууд (ХОЛИМОГ ч байж болно)
 *   4. эрх огт оноогоогүй           → [] (дуудагч нь бүлгийн нөөцөд шилжинэ)
 */
export function allowedStages(user, isAdmin) {
  if (isAdmin) return [1, 2, 3, 4];
  if (hasPermission(user, STAGE_ALL_PERMISSION)) return [1, 2, 3, 4];

  const groups = groupsOf(user);
  if (groups.some((g) => FULL_ACCESS_GROUPS.includes(g))) return [1, 2, 3, 4];

  // ── 1) SSO-гийн ЭРХ — ЭРХ МЭДЭЛТЭЙ эх сурвалж ───────────────────────
  //
  // 2026-08-08-нд `inspection_IV_add` SSO дээр үүсэж, ХАБ хэлтсийн бүлэгт
  // ОНООГДСОН. Түүнээс өмнө 4 дүгээр шатыг ролиор (INSPECTOR_ROLES)
  // тодорхойлж, эрхээс ӨМНӨ шалгадаг байв — тэгэхгүй бол 179-ийг зэрэг
  // агуулдаг мэргэжилтэн `inspection_list_add`-аас болж [1] болж хумигдах
  // байлаа.
  //
  // ⚠ Одоо эрэмбийг ЭРЭГЦҮҮЛЭВ: эрх түрүүлнэ. Ингэснээр SSO дээрээс эрхийг
  //   нь ХАСАХАД систем дагана. Өмнөх эрэмбээр ролийг эхэлж шалгадаг тул
  //   SSO-гийн хасалт үл тоомсорлогдож, «хатуу бичсэн» шинжтэй байв.
  const byPermission = [1, 2, 3, 4].filter((n) =>
    (STAGE_ADD_PERMISSIONS[n] || []).some((p) => hasPermission(user, p)),
  );
  if (byPermission.length) return byPermission;

  // ── 2) НӨӨЦ — SSO дээр шатны эрх ОГТ оноогоогүй хэрэглэгчид ─────────
  // Роль/бүлгийн хуучин логик. Эрх нэвтрээгүй нэгжүүд ажилласаар байна.
  const roles = Array.isArray(user?.userroles) ? user.userroles : [];
  if (INSPECTOR_ROLES.some((r) => roles.includes(r))) return [4];
  if (groups.some((g) => BN_HAB_GROUPS.includes(g))) return [1, 2, 3];
  return [];
}

/* ══════════════════════════════════════════════════════════════════════════
 *  УДИРДАМЖААР ЯВАГДАХ ХЯНАЛТ — ЗОРИЛТОТ ба ЭЭЛЖИТ БУС
 *
 *  ЯАГААД ТУСДАА ЛОГИК ВЭ:
 *    I-IV шат нь ДУГААРТАЙ, тогтсон маягттай (Хавсралт №2-5). Харин
 *    зорилтот хяналтын маягтыг журам «Удирдамжаар», ээлжит бусынхыг «—»
 *    гэж заасан тул тэдгээр нь дугаарын дарааллын гадна орших ӨӨР ТӨРӨЛ.
 *    Тиймээс `allowedStages` (1|2|3|4) -д багтаахгүй, кодоор нь ялгана.
 *
 *  ХЭН ХИЙХ ВЭ:
 *    Удирдамж нь ХОЁР ТҮВШИНД гардаг (inspection_directive.level_code):
 *        factory — үйлдвэрийн даргын/ХАБЭА-гийн удирдамж, БҮХ нэгжид
 *        bn      — тухайн бүтцийн нэгжийн даргын удирдамж
 *    Ингэснээр:
 *        ХАБЭА хэлтэс (IV шатны эрхтэй) → factory + bn аль алиныг нь
 *        БН-ийн ХАБ / удирдлага          → ЗӨВХӨН bn түвшний удирдамж
 *
 *  ⚠ ШИНЭ ЭРХ ЗОХИОГООГҮЙ: SSO дээр `inspection_targeted_add` гэх мэт эрх
 *    хараахан БАЙХГҮЙ. Хэрэв зохиовол доорх `DIRECTIVE_ADD_PERMISSIONS`-д
 *    нэмэхэд шууд давамгайлна — одоохондоо шатны эрхээс УЛБААЛЖ тодорхойлно.
 *    Эс бөгөөс эрхийг нэрлэсэн даруйдаа хэн ч зорилтот хяналт хийж
 *    чадахгүй болно.
 * ═══════════════════════════════════════════════════════════════════════ */

/** Тогтсон маягтгүй — удирдамжаас шалгах асуудлаа авдаг төрлүүд.
 *
 * ⚠ ЭЭЛЖИТ БУС-ЫГ ХАСАВ (2026-10-01). Журмаас «удирдамж» гэсэн заалтыг
 *   бүхэлд нь хайхад ЕРДӨӨ НЭГ л гарна: 2.7.1 — ЗОРИЛТОТ хяналт.
 *   Ээлжит бусын заалтууд (2.9 · 2.9.1 · 2.9.2 · 2.9.3) удирдамж
 *   шаардаагүй тул БАЙНГЫН ХЯНАЛТТАЙ ижил, батлагдсан шалгах хуудсаар
 *   эхэлнэ (хэрэглэгчийн шаардлага: «удирдамж гэхгүй мониторингийн
 *   хяналтын хуудас шиг адилхан үүсгэж эхлүүлэх»).
 */
export const DIRECTIVE_STAGE_CODES = ["targeted"];

/** ЭЭЛЖИТ БУС ХЯНАЛТ — журам 1.5.4, 2.9. Удирдамжгүй, хуудсаар. */
export const IRREGULAR_STAGE_CODE = "irregular";

/**
 * БАЙНГЫН ХЯНАЛТ (мониторинг) — журам 1.5.3, 2.8.
 *
 * ⚠ Удирдамжаар явагддаггүй тул `DIRECTIVE_STAGE_CODES`-д ОРООГҮЙ, гэхдээ
 *   журмын 2.8.4 нь «нэгж өөрийн БАЙНГЫН ХЯНАЛТЫН ШАЛГАХ ХУУДСЫГ
 *   боловсруулж … батлагдсан хуудасны дагуу ээлжийн туршид хяналт
 *   шалгалтыг явуулж» гэж заасан — өөрөөр хэлбэл I-III шаттай ЯГ ИЖИЛ
 *   бүтэцтэй. Өмнө нь «Хавсралт №6 нь дэвтэр» гэж үзээд эхлүүлэх цэснээс
 *   огт хассан байсан нь журмыг дутуу уншсан хэрэг: Хавсралт №6 нь үр
 *   дүнг бүртгэх ДЭВТЭР (4.3.2, 4.3.7), шалгах хуудас нь ӨӨР зүйл.
 *
 * ГҮЙЦЭТГЭГЧ (2.8.3): «бүтцийн нэгжүүдийн, хэлтсийн ХАБЭА-н инженерүүд
 *   явуулна. ХАБЭА-н инженер нь ХАБЭА-н товчооны даргын удирдлага дор».
 *   Тиймээс дугаарласан шатны эрхтэй хүн бүрд БИШ — ХАБЭА-гийн ажилтанд.
 */
export const MONITORING_STAGE_CODE = "monitoring";

/** Дугаарласан шатны код — `allowedStages`-ийн 1|2|3|4-тэй тохирно. */
export const NUMBERED_STAGE_CODES = { 1: "I", 2: "II", 3: "III", 4: "IV" };

/**
 * Ирээдүйд SSO дээр эрх нэрлэвэл энд нэмнэ. Хоосон массив = эрхээр
 * шалгахгүй, шатны эрхээс улбаалж тодорхойлно (доорх `allowedDirectiveLevels`).
 */
export const DIRECTIVE_ADD_PERMISSIONS = {
  targeted: [],
  irregular: [],
};

/**
 * Хэрэглэгчийн эхлүүлж болох УДИРДАМЖИЙН ТҮВШИН.
 *
 * @returns {string[]} ["factory","bn"] · ["bn"] · []
 *
 *   factory — үйлдвэрийн хэмжээний удирдамж (bn_code хоосон)
 *   bn      — тухайн нэгжийн удирдамж
 *
 * ⚠ Энэ нь ХАРАГДАХ удирдамжийг л шүүнэ. Аль нэгжийн өгөгдөл рүү хандахыг
 *   backend өөрөө bn_code-оор хязгаарладаг тул эрхийн жинхэнэ хаалт тэнд.
 */
export function allowedDirectiveLevels(user, isAdmin) {
  const stages = allowedStages(user, isAdmin);
  if (!stages.length) return [];
  // IV шатны эрхтэй = ХАБЭА хэлтэс / бүрэн эрх → үйлдвэрийн удирдамж ч
  if (stages.includes(4)) return ["factory", "bn"];
  // БН-ийн ХАБ, удирдлага → зөвхөн өөрийн нэгжийн удирдамжаар
  return ["bn"];
}

/**
 * Хэрэглэгчид НЭЭЛТТЭЙ бүх хяналтын төрлийн КОД.
 *
 * @returns {string[]} ж: ["I","II","III","targeted","irregular"]
 *                        ["IV","targeted","irregular"]
 *                        ["I","II","III","IV","targeted","irregular"]
 *
 * Шалгалт эхлүүлэх цонхны «Хяналтын шат» сонголтыг ЭНЭ жагсаалтаар
 * шүүнэ — өмнө нь хэн ч бүх 6 төрлийг сонгож чаддаг байсан бөгөөд
 * БН-ийн ажилтан IV шатны хуудсаар шалгалт эхлүүлж болох цоорхойтой байв.
 */
export function allowedStageCodes(user, isAdmin) {
  const stages = allowedStages(user, isAdmin);
  if (!stages.length) return [];
  const codes = stages.map((n) => NUMBERED_STAGE_CODES[n]).filter(Boolean);

  // Удирдамжаар явагдах төрөл — эрх нэрлэгдсэн бол түүгээр, эс бөгөөс
  // удирдамжийн түвшин нээлттэй хүн бүрд.
  const levels = allowedDirectiveLevels(user, isAdmin);
  DIRECTIVE_STAGE_CODES.forEach((code) => {
    const perms = DIRECTIVE_ADD_PERMISSIONS[code] || [];
    const byPerm = perms.length
      ? perms.some((p) => hasPermission(user, p))
      : levels.length > 0;
    if (byPerm) codes.push(code);
  });

  // Байнгын хяналт — ХАБЭА-н инженер/товчоо (журам 2.8.3). Практикт энэ нь
  // БН-ийн ХАБ (III шат) эсвэл ХАБЭА хэлтэс (IV шат)-ын эрхтэй хүмүүс.
  if (isAdmin || stages.includes(3) || stages.includes(4)) {
    codes.push(MONITORING_STAGE_CODE);
  }

  // ЭЭЛЖИТ БУС — удирдамжгүй болсон тул `DIRECTIVE_STAGE_CODES`-ийн
  // давталтаас гарсан; эндээс нэмнэ.
  //
  // ⚠ ХЭН эхлүүлэхийг НАРИЙСГААГҮЙ. Өмнө нь нөхцөл нь
  //   `allowedDirectiveLevels(...).length > 0` байсан бөгөөд тэр функц нь
  //   шатны эрхтэй хүн бүрд хоосон биш буцаадаг — өөрөөр хэлбэл шатны
  //   эрхтэй хүн БҮР ээлжит бус хяналт эхлүүлж чаддаг байсан. Дээрх
  //   `stages.length` шалгалтаар тэр нь аль хэдийн хангагдсан тул
  //   нөхцөлгүй нэмэхэд хэн ч ЭРХЭЭ АЛДАХГҮЙ.
  // ⚠ Журам 2.9.1 нь «ХАБЭА-н хэлтсээс зохион байгуулна» гэсэн тул хожим
  //   IV шатаар нарийсгаж болно. Гэхдээ тэр нь ТУСДАА шийдвэр — ажлын
  //   дундуур хүмүүсийг чимээгүй хаахгүйн тулд одоо хөндөөгүй.
  codes.push(IRREGULAR_STAGE_CODE);
  return codes;
}

/**
 * 4 дүгээр шатны шалгалт хийх эрхтэй SSO роль.
 *
 * ХАБ хэлтсийн мэргэжилтэн ба лавлахад эрх нь тавигдсан бусад хэлтэс
 * (эрчим зүй, механик, ГАБ, ЭА …) эдгээрийн аль нэгийг эзэмшинэ.
 */
export const INSPECTOR_ROLES = [
  "hab_dept_specialist",
  "hab_meregjilten",
  "hse_specialist",
  "riskplan_sent",
];

/** SSO-гоос ирсэн бүлгүүдийг массив болгож цэвэрлэнэ. */
export function groupsOf(user) {
  const raw = user?.info?.usergroup || user?.usergroup || "";
  return String(raw)
    .split(",")
    .map((g) => g.trim())
    .filter(Boolean);
}

/**
 * Хэрэглэгчид тохирох зөрчил бүртгэх ГОРИМЫГ шийднэ.
 *
 * @param {object} user     userContext-ийн `user`
 * @param {boolean} isAdmin `userContext.isAdmin()`-ийн үр дүн
 *
 * @returns {"all"|"hab_dept_violation"|"bn_violation"|null}
 *          `null` — эдгээрийн аль нь ч биш (дуудагч өөрөө шийднэ)
 *
 * ⚠ ДАРААЛАЛ ЧУХАЛ: админ → роль → бүлэг. Ролийг бүлгээс ӨМНӨ шалгахгүй
 *   бол 179-ийг зэрэг агуулдаг мэргэжилтэн доод шатанд хаагдана.
 */
export function resolveViolationMode(user, isAdmin) {
  // Эрхийн шийдвэр НЭГ л газраас гарна — `allowedStages`. Өмнө нь энд
  // бүлэг/ролийн логик ДАХИН бичигдсэн байсан тул хоёр функц зөрөх
  // эрсдэлтэй байв.
  //
  // Горим нь зөвхөн МАЯГТЫН БҮРДЭЛ (гарчиг, ямар талбар харагдах)-ыг
  // тодорхойлно. Аль шат идэвхтэй болохыг `allowedStages` нарийвчлан
  // шийддэг тул холимог эрх (ж: зөвхөн 2 ба 4-р шат) ч зөв ажиллана.
  const stages = allowedStages(user, isAdmin);
  if (!stages.length) return null;
  if (stages.length === 4) return "all";
  // ⚠ 4 дүгээр шат ОРСОН эсэхээр шийднэ, «ЗӨВХӨН 4» гэж биш.
  //   ХАБ хэлтсийн мэргэжилтэн бүлэг 179-ийг зэрэг агуулдаг тул SSO-гоос
  //   `inspection_list_add` (1-р шат) ч өвлөгдөж, шат нь [1,4] гэсэн
  //   ХОЛИМОГ болдог. Хуучин `every(n => n === 4)` шалгуур ийм хүнийг
  //   «БН-ийн ХАБ» гэж ангилж, маягтын гарчиг буруу гарч байв.
  if (stages.includes(4)) return "hab_dept_violation";
  return "bn_violation";
}
